import { useState, useEffect } from 'react';
import { useMDSContext } from '@metservice/use-mds';
import { generalDataset } from '@mono/types/src/mds';

interface UseDatasetByIdProps {
    datasetId?: string;
}
export const useDatasetById = ({ datasetId }: UseDatasetByIdProps) => {
    const [error, setError] = useState<string | null>();
    const [dataset, setDataset] = useState<generalDataset>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const mds = useMDSContext();

    useEffect(() => {
        if (!datasetId) {
            return;
        }

        mds.findDatasets({
            id: [datasetId],
        }).then((response) => {
            if (response['basic-datasets'].length !== 0) {
                setDataset(response['basic-datasets'][0]);
                return;
            }
            if (response['datasource-datasets'].length !== 0) {
                setDataset(response['datasource-datasets'][0]);
                return;
            }
            setDataset(undefined);
            setIsLoading(false);
            setError('dataset not found');
        });
    }, [datasetId]);

    return [dataset, isLoading, error] as const;
};
